module.exports = __webpack_public_path__ + "media/images/area-badges/new-fuel-sources-40d6b8a2fa663eb7dc93580c0b7d412c.svg";